export default data => {
    return data.map(network => ({
        url: network.Url,
        title: network.Titulo,
        icon: network.Icono
    }));
}